<template>
  <div>
    <titulo-modulo titulo="Limite Conta Consumo" />
    <v-progress-linear indeterminate v-if="carregando"></v-progress-linear>
    <template v-else>
      <v-row v-if="limites.length > 0">
        <v-col cols="12">
          <v-card flat class="mb-2" v-for="(limite, i) in limites" :key="i">
            <v-card-title class="subtitle-1">{{
              limite.categoria
            }}</v-card-title>
            <v-card-subtitle class="title font-weight-bold green--text pb-0">{{
              formatoMoeda(limite.valorutilizado)
            }}</v-card-subtitle>

            <v-card-actions>
              <detalhes-conta-consumo
                v-if="limite.detalhes.length > 0"
                :limite="limite"
              />
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <!-- NOVO CARD: CALENDÁRIO ATUALIZAÇÃO LIMITES -->
      <v-row class="mt-1" v-if="!carregandoCalendario">
        <v-col cols="12">
          <!-- Se não houver data retornada -->
          <v-card
            v-if="!calendarioLimite.data"
            flat
            class="grey lighten-4 py-3 text-center rounded-lg"
          >
            Limite não cadastrado
          </v-card>

          <!-- Card Ativo (Gradiente) -->
          <v-card
            v-else
            dark
            class="rounded-lg elevation-2 clickable-card"
            style="
              background: linear-gradient(to bottom right, #1565c0, #42a5f5);
            "
            @click="abrirCalendario"
          >
            <v-card-text class="text-center pa-4 text-white">
              <div
                class="font-weight-black"
                style="font-size: 15px; line-height: 1.1"
              >
                Calendário Atualização<br />Limites Conta Consumo
              </div>
              <v-divider
                class="my-2"
                style="border-color: rgba(255, 255, 255, 0.3)"
              ></v-divider>
              <div
                class="font-weight-medium"
                style="font-size: 13px; opacity: 0.85"
              >
                *última atualização:
              </div>
              <div
                class="font-weight-black mt-1"
                style="font-size: 24px; line-height: 1"
              >
                {{ formatarData(calendarioLimite.data) }}
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-alert class="mt-3" text type="info" v-if="limites.length === 0">
        Não há informações sobre o limite consumido
      </v-alert>
    </template>

    <!-- MODAL DO CALENDÁRIO -->
    <v-dialog v-model="dialogCalendario" max-width="520" scrollable>
      <v-card class="cal-dialog rounded-xl">
        <div class="cal-head">
          <div class="d-flex align-center">
            <v-avatar size="46" class="cal-avatar">
              <v-icon color="#6A3FD9" size="26">mdi-calendar-month</v-icon>
            </v-avatar>
            <div class="ml-3">
              <div class="cal-title">Calendário Atualização Limite</div>
              <div class="cal-subtitle">
                Data Atualização
                {{ formatarData(calendarioLimite.data) || "-" }}
              </div>
            </div>
          </div>
          <v-btn icon @click="dialogCalendario = false">
            <v-icon size="28">mdi-close</v-icon>
          </v-btn>
        </div>

        <v-divider></v-divider>

        <v-card-text class="pt-4 px-4 pb-6" style="background-color: #fafafa">
          <div v-if="carregandoProximos" class="text-center py-6">
            <v-progress-circular
              indeterminate
              color="blue"
            ></v-progress-circular>
          </div>
          <div
            v-else-if="proximosCalendario.length === 0"
            class="text-center py-6"
          >
            <span class="text-body-1"
              >Não há mais datas futuras disponíveis.</span
            >
          </div>
          <div v-else class="cal-list">
            <div
              v-for="(item, idx) in proximosCalendario"
              :key="idx"
              class="cal-item"
              :class="{ 'cal-item--active': isMesAtual(item.data) }"
            >
              <div
                class="cal-item-avatar"
                :class="{ 'cal-item-avatar--active': isMesAtual(item.data) }"
              >
                {{ numeroMes(item.data) }}
              </div>

              <div class="cal-item-content">
                <div
                  class="cal-item-month"
                  :class="{ 'cal-item-month--active': isMesAtual(item.data) }"
                >
                  {{ nomeMes(item.data) }}
                </div>
                <!-- MESES PASSADOS: VERDE ("Última atualização") -->
                <div
                  v-if="isMesPassado(item.data)"
                  class="cal-item-date"
                  style="color: #4caf50; font-weight: 600"
                >
                  Última atualização {{ formatarData(item.data) }}
                </div>
                <!-- MÊS ATUAL / FUTURO: VERMELHO ("Próxima atualização") -->
                <div
                  v-else
                  class="cal-item-date"
                  style="color: #e53935; font-weight: 600"
                >
                  Próxima atualização {{ formatarData(item.data) }}
                </div>
              </div>

              <div v-if="isMesAtual(item.data)" class="cal-item-badge">
                Mês atual
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import TituloModulo from "../../components/TituloModulo.vue";
import { formatMoeda } from "@/global";
import DetalhesContaConsumo from "./components/DetalhesContaConsumo.vue";

export default {
  components: { TituloModulo, DetalhesContaConsumo },
  data: () => ({
    carregando: false,
    carregandoCalendario: false,
    carregandoProximos: false,
    dialogCalendario: false,
    limites: [],
    calendarioLimite: {},
    proximosCalendario: [],
  }),
  methods: {
    async getLimitesContaConsumo() {
      this.limites = [];
      await axios
        .get("/colaborador/financeiro?funcao=GASTOS-CONTA-CONSUMO")
        .then((res) => {
          if (res.data.success) {
            this.limites = res.data.data;
          } else this.$toasted.error(res.data.msg);
        })
        .catch((e) => this.$toasted.error(e));
    },

    async getCalendarioLimite() {
      this.carregandoCalendario = true;
      try {
        const res = await axios.get(
          "/colaborador/financeiro?funcao=BUSCAR-CALENDARIO-LIMITE",
        );
        let data = res.data;
        if (typeof data === "string") data = JSON.parse(data);

        // Pega o array do retorno se for { success, data: [...] }
        const payload = data?.data || data;

        if (Array.isArray(payload) && payload.length > 0) {
          this.calendarioLimite = payload[0];
        } else {
          this.calendarioLimite = {};
        }
      } catch (e) {
        console.error("Erro ao carregar calendário:", e);
      } finally {
        this.carregandoCalendario = false;
      }
    },

    async getCalendarioLimiteProximos(meses = 12) {
      this.carregandoProximos = true;
      try {
        const res = await axios.get(
          `/colaborador/financeiro?funcao=BUSCAR-CALENDARIO-LIMITE-PROXIMOS&meses=${meses}`,
        );
        let data = res.data;
        if (typeof data === "string") data = JSON.parse(data);

        const payload = data?.data || data;

        if (Array.isArray(payload)) {
          this.proximosCalendario = payload;
        } else {
          this.proximosCalendario = [];
        }
      } catch (e) {
        console.error("Erro ao carregar próximos calendários:", e);
      } finally {
        this.carregandoProximos = false;
      }
    },

    async abrirCalendario() {
      this.dialogCalendario = true;
      if (this.proximosCalendario.length === 0) {
        await this.getCalendarioLimiteProximos(12);
      }
    },

    // ======== UTILS DE FORMATAÇÃO DE DATA ======== //
    // O backend retorna dd-MM-yyyy ou dd/MM/yyyy ou ISO
    parseDataStr(dataStr) {
      if (!dataStr) return null;

      // Tenta ISO YYYY-MM-DD
      let dt = new Date(dataStr + "T12:00:00Z");
      if (
        !isNaN(dt.getTime()) &&
        dataStr.includes("-") &&
        dataStr.split("-")[0].length === 4
      ) {
        return dt;
      }

      // Tenta dd/MM/yyyy ou dd-MM-yyyy
      let parts = dataStr.includes("/")
        ? dataStr.split("/")
        : dataStr.split("-");
      if (parts.length === 3) {
        let dia = parseInt(parts[0], 10);
        let mes = parseInt(parts[1], 10) - 1;
        let ano = parseInt(parts[2], 10);
        return new Date(ano, mes, dia);
      }
      return null;
    },

    formatarData(dataStr) {
      const dt = this.parseDataStr(dataStr);
      if (!dt) return dataStr;
      const d = String(dt.getDate()).padStart(2, "0");
      const m = String(dt.getMonth() + 1).padStart(2, "0");
      const y = dt.getFullYear();
      return `${d}/${m}/${y}`;
    },

    numeroMes(dataStr) {
      const dt = this.parseDataStr(dataStr);
      if (!dt) return "--";
      return String(dt.getMonth() + 1).padStart(2, "0");
    },

    nomeMes(dataStr) {
      const dt = this.parseDataStr(dataStr);
      if (!dt) return "";
      const meses = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ];
      return meses[dt.getMonth()];
    },

    isMesAtual(dataStr) {
      const dt = this.parseDataStr(dataStr);
      if (!dt) return false;
      const hoje = new Date();
      return (
        dt.getMonth() === hoje.getMonth() &&
        dt.getFullYear() === hoje.getFullYear()
      );
    },

    isMesPassado(dataStr) {
      const dt = this.parseDataStr(dataStr);
      if (!dt) return false;
      const hoje = new Date();

      // Se for ano passado, ou mesmo ano mas mês passado
      if (dt.getFullYear() < hoje.getFullYear()) return true;
      if (
        dt.getFullYear() === hoje.getFullYear() &&
        dt.getMonth() < hoje.getMonth()
      )
        return true;

      return false;
    },

    formatoMoeda(value) {
      return formatMoeda(value);
    },
  },
  async mounted() {
    this.carregando = true;
    await Promise.all([
      this.getLimitesContaConsumo(),
      this.getCalendarioLimite(),
    ]);
    this.carregando = false;
  },
};
</script>

<style scoped>
.clickable-card {
  cursor: pointer;
  transition: transform 0.1s ease, box-shadow 0.1s ease;
}
.clickable-card:active {
  transform: scale(0.98);
}

/* Modal UI idêntica ao app Flutter */
.cal-dialog {
  overflow: hidden;
  background-color: white;
}

.cal-head {
  padding: 16px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cal-avatar {
  background: #e9e1ff;
}

.cal-title {
  font-weight: 800;
  font-size: 14px;
  color: #2c2c2c;
}

.cal-subtitle {
  margin-top: 2px;
  font-size: 12px;
  color: #757575;
  font-weight: 500;
}

.cal-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cal-item {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  border-radius: 14px;
  background: white;
  border: 1px solid #e0e0e0;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
}

.cal-item--active {
  background: #f0f4ff;
  border-color: #64b5f6;
  border-width: 1.4px;
}

.cal-item-avatar {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  background: #ddecf2;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 18px;
  color: #708a96;
}

.cal-item-avatar--active {
  background: linear-gradient(135deg, #4da0ff, #2e8ea6);
  color: white;
}

.cal-item-content {
  flex: 1;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
}

.cal-item-month {
  font-size: 14px;
  font-weight: 700;
  color: #3a3a3a;
}

.cal-item-month--active {
  color: #1a56db;
}

.cal-item-date {
  font-size: 12px;
  font-weight: 500;
  color: #4a4a4a;
}

.cal-item-date--active {
  font-weight: 700;
}

.cal-item-badge {
  padding: 4px 10px;
  border-radius: 14px;
  background: #e3f2fd;
  color: #1976d2;
  font-weight: 700;
  font-size: 11px;
}
</style>
